
import { Header, Navbar, LeftSidebar, Footer } from "@/components/partials";
export default {
  name: "App",
  components: {
    Header,
    Navbar,
    LeftSidebar,
    Footer,
  },
  computed: {
    //
  },
  // data: () => ({
  //   layout: "div",
  // }),
  mounted: function () {
    //console.log('App component mounted.');
  },
  created() {
    //
  },
};
